
import blog1 from '../img/blogs/blog1.svg';
import blog2 from '../img/blogs/blog2.svg';
import blog3 from '../img/blogs/blog3.svg';
import blog4 from '../img/blogs/blog4.svg';
import blog5 from '../img/blogs/blog5.svg';

const blogs = [
    {
        id:1, 
        title:'How to Work from  Home',
        date:'01',
        month:'April',
        image:blog1,
       
    },
        {
        id:2, 
        title:'How to Use SEO Efficiently',
        date:'01',
        month:'April',
        image:blog2
    },
        {
        id:3, 
        title:'How to Check SEO Efficiently',
        date:'01',
        month:'April',
        image:blog3
    },
        {
        id:4, 
        title:'How to Test Code Efficiently',
        date:'01',
        month:'April',
        image:blog4
    },
        {
        id:5, 
        title:'How to Analysis Bug Efficiently',
        date:'01',
        month:'April',
        image:blog5
    },
    {
        id:6, 
        title:'How to Tse SEO Efficiently',
        date:'01',
        month:'April',
        image:blog5,
         link:'https://www.google.com.hk/'
    },
]

export default blogs; 
